import React, { useState } from "react";
import AllChats from "./../components/AllChats";
import Chat from "./../components/Chat";

export default function Chats() {
  const [selectedChat, setSelectedChat] = useState("private1");

  const handleChangeChat = (chat) => {
    setSelectedChat(chat);
  };

  return (
    <div className="chat-main-page">
      {selectedChat === "all" && (
        <AllChats onChangeChat={(chat) => handleChangeChat(chat)} />
      )}
      {selectedChat === "group1" && (
        <Chat
          chatType="group1"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "group2" && (
        <Chat
          chatType="group2"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private1" && (
        <Chat
          chatType="private1"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private2" && (
        <Chat
          chatType="private2"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private3" && (
        <Chat
          chatType="private3"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private4" && (
        <Chat
          chatType="private4"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private5" && (
        <Chat
          chatType="private5"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private6" && (
        <Chat
          chatType="private6"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private7" && (
        <Chat
          chatType="private7"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private8" && (
        <Chat
          chatType="private8"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
      {selectedChat === "private9" && (
        <Chat
          chatType="private9"
          onChangeChat={(chat) => handleChangeChat(chat)}
        />
      )}
    </div>
  );
}
